module.exports = __webpack_public_path__ + "img/20-large.dc066efa.png";